import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";

const AdminSeguros = () => {
  const [seguros, setSeguros] = useState([]);
  const [tipoActivo, setTipoActivo] = useState("auto");
  const token = localStorage.getItem("token");
  const [notas, setNotas] = useState({});
  const navigate = useNavigate();

  const tabs = [
    { label: "Auto", value: "auto" },
    { label: "Vida", value: "vida" },
    { label: "Hogar", value: "hogar" },
    { label: "Viajes", value: "viajes" },
    { label: "Gastos Medicos", value: "gastosmedicosmayores" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const endpoints = {
        auto: "ocitaseguroauto",
        vida: "ocitasegurovida",
        hogar: "ocitasegurohogar",
        viajes: "ocitaseguroviajes",
        gastosmedicosmayores: "ocitasegurogastosmedicosmayores",
      };
      try {
        const response = await fetch(`https://ricardodiaztuasesorfinanciero.com/api/${endpoints[tipoActivo]}`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        console.log(data)
        
        if (data && data) {
          setSeguros(data);
        }
      } catch (error) {
        console.error("Error al obtener las citas", error);
      }
    };
    fetchData();
  }, [tipoActivo]);

const handleGuardar = async (id) => {
  const endpoints = {
    auto: "actualizarnotaautos",
    vida: "actualizarnotavida",
    hogar: "actualizarnotahogar",
    viajes: "actualizarnotaviajes",
    gastosmedicosmayores: "actualizarnotagastosmedicosm",
  };
  const nota = notas[id] || "";
  try {
    const response = await fetch(`https://ricardodiaztuasesorfinanciero.com/api/${endpoints[tipoActivo]}`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: id,
        nota: nota,
      }),
    });

    if (response.ok) {
        Swal.fire({
              title: "Anotacion guardada.",
              icon: "success",
              draggable: true
            });
    } else {
        Swal.fire({
              title: "No se pudo guardar la anotacion.",
              icon: "error",
              draggable: true
            });
    }
  } catch (error) {
    console.error("Error al enviar los datos [N2]", error);
    alert("Error en la conexión");
  }
};

const handleEliminar = async (id) => {
  const endpoints = {
    auto: "eliminarcitaseguroauto",
    vida: "eliminarcitasegurovida",
    hogar: "eliminarcitasegurohogar",
    viajes: "eliminarcitaseguroviajes",
    gastosmedicosmayores: "eliminarcitasegurogastosmedicosmayores",
  };

  const resultado = await Swal.fire({
    title: "¿Estás seguro?",
    text: "Esta acción eliminará la cita permanentemente.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#c53030",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Sí, eliminar",
    cancelButtonText: "Cancelar",
  });

  if (!resultado.isConfirmed) return;

  if (!token) {
    Swal.fire("Error", "No se encontró el token de autenticación. [N1]", "error");
    return;
  }

  try {
    const response = await fetch(`https://ricardodiaztuasesorfinanciero.com/api/${endpoints[tipoActivo]}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ id }),
    });

    const result = await response.json();

    if (response.ok && result?.success !== false) {
      setSeguros((prev) => prev.filter((cita) => cita.id !== id));
      const nuevasNotas = { ...notas };
      delete nuevasNotas[id];
      setNotas(nuevasNotas);
      Swal.fire("Eliminada", "La cita fue eliminada correctamente.", "success");
    } else {
      Swal.fire("Error", result?.message || "No se pudo eliminar la cita. [N3]", "error");
      console.error("Error del servidor:", result);
    }
  } catch (error) {
    console.error("Error al eliminar la cita:", error);
    Swal.fire("Error", "Ocurrió un error en la conexión. [N5]", "error");
  }
};


  const handleNotaChange = (id, valor) => {
    setNotas({ ...notas, [id]: valor });
  };

  return (
    <div style={styles.container}>
      <div style={styles.cabecera}>
        <h2 style={styles.tituloCabecera}>📋 Panel de administración de seguros</h2>
        <div style={styles.botonera}>
          <button style={styles.botonRegresar} onClick={() => navigate('/')}>🏠 Menú Principal</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/CitasClientes')}>📆 Citas Pendientes</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/citasdespues')}>👥 Citas Finalizadas</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/adminseguros')}>📃 Formularios</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/horariosadmin')}>🕒 Horarios</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/adminblog')}>📰 Blog</button>
          <button style={styles.botonRegresar} onClick={() => navigate('/aiuda')}>⚙️ Ayuda</button>
        </div>
      </div>

      <div style={styles.tabs}>
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => {
              if (tipoActivo !== tab.value) {
                setTipoActivo(tab.value);
                setSeguros([]);
                setNotas({});
              }
            }}
            style={{
              ...styles.tab,
              backgroundColor: tipoActivo === tab.value ? "#0c1f4d" : "#ccc",
              color: "white",
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div style={styles.grid}>
        {seguros.map((item) => (
          <div key={item.id} style={styles.card}>
            <div style={styles.infoGrid}>
              <div style={styles.seccion}>
                <h4 style={styles.subtitulo}>👤 Datos Personales</h4>
                <p><strong>Nombre:</strong> {item.Nombre}</p>
                <p><strong>Edad:</strong> {item.Edad}</p>
                <p><strong>Género:</strong> {item.Genero}</p>
                <p><strong>Correo:</strong> {item.Correo}</p>
                <p><strong>Teléfono:</strong> {item.Numero}</p>
                {item.Hijos && <p><strong>Hijos:</strong> {item.Hijos}</p>}
              </div>
              <div style={styles.seccion}>
                <h4 style={styles.subtitulo}>📄 Detalles del Seguro</h4>
                {item.Modelo && <p><strong>Modelo:</strong> {item.Modelo}</p>}
                {item.Marca && <p><strong>Marca:</strong> {item.Marca}</p>}
                {item.Version && <p><strong>Versión:</strong> {item.Version}</p>}
                {item.Año && <p><strong>Año:</strong> {item.Año}</p>}
                {item.tipodevehiculo && <p><strong>Tipo:</strong> {item.tipodevehiculo}</p>}
                {item.Destino && <p><strong>Destino:</strong> {item.Destino}</p>}
                {item.Salida && <p><strong>Fecha de Salida:</strong> {item.Salida}</p>}
                {item.TiempoDeEstadia && <p><strong>Estadía:</strong> {item.TiempoDeEstadia}</p>}
                {item.CodigoPostal && <p><strong>Código Postal:</strong> {item.CodigoPostal}</p>}
                {item.Ciudad && <p><strong>Ciudad:</strong> {item.Ciudad}</p>}
                {item.Ingresos && <p><strong>Ingresos:</strong> {item.Ingresos}</p>}
                {item.Personasextras && (
                  <div>
                    <strong>Personas Extra:</strong>
                    {JSON.parse(item.Personasextras).map((persona, index) => (
                      <div key={index} style={{ marginLeft: '10px' }}>
                        <p>Nombre: {persona.name}</p>
                        <p>Edad: {persona.age}</p>
                        <p>Relación: {persona.relationship}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <textarea
              placeholder="Escribe una nota..."
              value={notas[item.id] !== undefined ? notas[item.id] : (item.nota || "")}
              onChange={(e) => handleNotaChange(item.id, e.target.value)}
              style={styles.textarea}
            />

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <button style={{ ...styles.btnGuardar }} onClick={() => handleGuardar(item.id)}>
                💾 Guardar
              </button>
              <button style={styles.btnEliminar} onClick={() => handleEliminar(item.id)}>
                🗑️ Eliminar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "50px 40px",
    fontFamily: "Segoe UI, sans-serif",
    backgroundColor: "#eef2f7",
    minHeight: "100vh",
  },
  cabecera: {
    backgroundColor: '#102a43',
    color: 'white',
    padding: '20px',
    borderRadius: '12px',
    marginBottom: '30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  tituloCabecera: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  tabs: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "10px",
    marginBottom: "30px",
  },
  tab: {
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "30px",
  },
  card: {
    backgroundColor: "#334e68",
    color: "white",
    padding: "25px",
    borderRadius: "16px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginTop: "1%"
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "5% 20px",
    marginBottom: "-15%"
  },
  seccion: {
    marginBottom: "35%",
  },
  subtitulo: {
    fontSize: "16px",
    marginBottom: "8px",
    borderBottom: "1px solid white",
    paddingBottom: "4px",
    fontWeight: "bold",
  },
  textarea: {
    padding: "10px",
    borderRadius: "8px",
    fontSize: "14px",
    border: "none",
    resize: "none",
    height: "80px",
    backgroundColor: "#f7fafc",
    color: "#1a202c",
  },
  btnEliminar: {
    backgroundColor: "#c53030",
    color: "white",
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  btnGuardar: {
    backgroundColor: "#2f855a",
    color: "white",
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  botonRegresar: {
    backgroundColor: '#334e68',
    border: 'none',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '8px',
    cursor: 'pointer',
    marginLeft: '10px',
  },
  botonera: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '15px',
  },
};

export default AdminSeguros;
